import { Rocket, PlayCircle, ExternalLink } from 'lucide-react';
import { ModalPanel, Button } from '@/contasis';
import { useUpgradePlan } from '@/contexts/ContextoUpgradePlan';
import { URL_VIDEO_EXPLICATIVO, construirUrlSuscripcion } from '@/utils/enlacesBilling';
import { obtenerEtiquetaAccionPlan } from '@/utils/planCapacidad';
import { storageService } from '@/utils/storage';
import { useSuscripcion } from '@/hooks/useSuscripcion';

export const ModalMejoraPlan = () => {
  const { capacidadActiva, cerrarModalUpgrade } = useUpgradePlan();
  const suscripcion = useSuscripcion();

  if (!capacidadActiva) return null;

  const urlSuscripcion = construirUrlSuscripcion(storageService.getEmpresaId(), {
    planSku: suscripcion?.planSku ?? undefined,
  });

  return (
    <ModalPanel
      isOpen
      title="Mejora tu plan"
      subtitle="Esta función está disponible en un plan superior"
      size="medium"
      onClose={cerrarModalUpgrade}
      footerActions={
        <>
          <Button
            variant="ghost"
            size="sm"
            icon={<PlayCircle className="w-4 h-4" />}
            onClick={() => window.open(URL_VIDEO_EXPLICATIVO, '_blank')}
          >
            Ver video
          </Button>
          <Button
            variant="primary"
            size="sm"
            icon={<Rocket className="w-4 h-4" />}
            onClick={() => window.open(urlSuscripcion, '_blank')}
          >
            {obtenerEtiquetaAccionPlan()}
          </Button>
        </>
      }
    >
      <div className="px-6 py-8 flex flex-col items-center text-center gap-4">
        <div className="w-16 h-16 rounded-2xl bg-brand-light flex items-center justify-center">
          <Rocket className="w-8 h-8 text-brand" />
        </div>
        <div className="space-y-1.5 max-w-sm">
          <h3 className="font-display text-h5 text-primary">Desbloquea esta función</h3>
          <p className="text-ui-sm text-secondary">
            Esta funcionalidad no está incluida en tu plan actual. Mejora tu plan para gestionarla por completo,
            junto con el resto de funciones avanzadas de Senciyo.
          </p>
        </div>
        <p className="text-caption text-tertiary flex items-center gap-1.5">
          <ExternalLink className="w-3.5 h-3.5" />
          Te lleva a Senciyo Billing, donde se gestiona tu suscripción
        </p>
      </div>
    </ModalPanel>
  );
};
